import * as React from "react";

import HelpTooltip from "../commons/HelpTooltip";
import TOOLTIPS from "../data/tooltips/tooltips.json";


export function HelpTooltipHTML(props: { children: string }) {
    return <HelpTooltip>
        <span dangerouslySetInnerHTML={{__html: props.children}} />
    </HelpTooltip>
}

export type ITooltipKey = keyof typeof TOOLTIPS;

export function tooltip(key: ITooltipKey) {
    return <HelpTooltipHTML>{TOOLTIPS[key]}</HelpTooltipHTML>
}
